import { useState } from 'react'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'
import MFAccordion from '../../ui-components/MFAccordion'
import TextAndInfo from '../../ui-components/TextAndInfo'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import VaulDrawer from '../../BottomSheetComponents/VaulDrawer'
import { TaxesContent } from '../../BottomSheetComponents/TaxesContent'
import { TaxesBody } from './TaxesBody'

const FUND_INFORMATION_SCREEN_NAME = `MF_L2_Fund_Information`

export const Taxes = () => {
  const { isin, data } = useMetaDataContext()
  const [isTaxesAccordionOpen, setIsTaxesAccordionOpen] = useState(false)
  const [bottomSheetContentKey, setBottomSheetContentKey] = useState<any>(null)
  const [openBottomSheet, setOpenBottomSheet] = useState(false)

  const renderBottomSheetContent = () => {
    switch (bottomSheetContentKey) {
      case 'taxes':
        return (
          <TaxesContent
            onDismiss={() => setOpenBottomSheet((open) => !open)}
            ScreenName={FUND_INFORMATION_SCREEN_NAME}
          />
        ) // Replace with actual content/component
      default:
        return null
    }
  }

  return (
    <>
      <MFAccordion
        title='Taxation'
        middleContent={
          <TextAndInfo
            text='Taxation'
            onInfoClick={(event) => {
              event.stopPropagation()
              setBottomSheetContentKey('taxes')
              setOpenBottomSheet((open) => !open)
            }}
          />
        }
        isExpanded={isTaxesAccordionOpen}
        onAccordionClick={() => {
          setIsTaxesAccordionOpen((isTaxesAccordionOpenPrev) => {
            trackEvent({
              eventName: EventNames.UserClicked,
              payload: {
                eventId: 'Taxes',
                responseName: isTaxesAccordionOpenPrev ? 'Collapse' : 'Expand',
                ScreenName: FUND_INFORMATION_SCREEN_NAME,
                fundName: isin,
                screenType: 'MF_L2'
              }
            })
            return !isTaxesAccordionOpenPrev
          })
        }}
        isBorderTop={true}
      >
        <div className='flex flex-col gap-3 pb-[16px]'>
          <TaxesBody taxCategory={data?.taxCategory ?? TaxCategories.NON_EQUITY_OTHERS} />
        </div>
      </MFAccordion>
      <VaulDrawer open={openBottomSheet} setOpen={setOpenBottomSheet}>
        {renderBottomSheetContent()}
        {/* <FundInformationContent onDismiss={() => setOpenBottomSheet((open) => !open)} /> */}
      </VaulDrawer>
    </>
  )
}
